export default function /* @ngInject */ OrderResource($resource, config) {
    let urlBase = `${config.accountsApiUrl}/api/v1/stripe`;
    let actions = {
        checkout: {
            url: `${urlBase}/checkout`,
            method: 'POST'
        },
        order: {
            url: `${urlBase}/orders/:invoice`,
            method: 'GET',
            cache: true
        },
        charge: {
            url: `${urlBase}/charge`,
            method: 'POST'
        },
        calculateTax: {
            url: `${urlBase}/calculate-tax`,
            method: 'POST'
        },
        cancelSubscription: {
            url: `${urlBase}/subscriptions`,
            method: 'DELETE',
            data: {
                group_name: 'CV'
            },
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            }
        }
    };

    return $resource(urlBase, {}, actions);
}



// WEBPACK FOOTER //
// ./payments/resources/order.js